export default "__VITE_ASSET__D_AKSz5q__"